var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.501C13.5 14.8817 14.8431 16.001 16.5 16.001C18.1569 16.001 19.5 14.8817 19.5 13.501C19.5 12.1203 18.1569 11.001 16.5 11.001C14.8431 11.001 13.5 12.1203 13.5 13.501ZM13.5 13.501C11.1131 13.501 8.82387 12.7108 7.13604 11.3043C5.44821 9.89775 4.5 7.9901 4.5 6.00098M4.5 6.00098C6.15685 6.00098 7.5 4.88169 7.5 3.50098C7.5 2.12026 6.15685 1.00098 4.5 1.00098C2.84315 1.00098 1.5 2.12026 1.5 3.50098C1.5 4.88169 2.84315 6.00098 4.5 6.00098ZM4.5 6.00098V16.001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectActive);
export default __webpack_public_path__ + "static/media/project-active.874b28653173840f0fd7c9e0ceeb4085.svg";
export { ForwardRef as ReactComponent };